var _a;
import { IntegrationType } from '../enum';
/**
 * The credential fields the UI collects per integration type — one source of truth for the form's
 * completeness check, the request payload and the validation schema.
 *
 * Mirrors `integrations.constants.ts` on the API, which is the authority: the server rejects anything
 * this list gets wrong. The one intentional difference is Aspect's optional `scope` override, which the
 * API accepts but no screen collects.
 */
export var CREDENTIAL_FIELDS_BY_TYPE = (_a = {},
    _a[IntegrationType.Genesys] = [
        { name: 'clientId', kind: 'text', required: true },
        { name: 'clientSecret', kind: 'secret', required: true },
        { name: 'region', kind: 'text', required: true },
    ],
    _a[IntegrationType.Aspect] = [
        { name: 'apiBaseUrl', kind: 'url', required: true },
        { name: 'tokenUrl', kind: 'url', required: true },
        { name: 'clientId', kind: 'text', required: true },
        { name: 'clientSecret', kind: 'secret', required: true },
    ],
    _a);
export var credentialFieldsFor = function (type) { var _a; return (_a = CREDENTIAL_FIELDS_BY_TYPE[type]) !== null && _a !== void 0 ? _a : []; };
